import { render } from "./AppointmentRecords.vue?vue&type=template&id=6422cf92&scoped=true"
import script from "./AppointmentRecords.vue?vue&type=script&lang=js"
export * from "./AppointmentRecords.vue?vue&type=script&lang=js"

import "./AppointmentRecords.vue?vue&type=style&index=0&id=6422cf92&scoped=true&lang=css"
import "./AppointmentRecords.vue?vue&type=style&index=1&id=6422cf92&scoped=true&lang=css"
import "./AppointmentRecords.vue?vue&type=style&index=2&id=6422cf92&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6422cf92"]])

export default __exports__